import React from "react";

function At() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      aria-hidden="true"
      className="icon h-[1.15rem] w-[1.15rem]"
      viewBox="0 0 256 256"
    >
      <g fill="currentColor">
        <path
          d="M224 128a96 96 0 11-96-96 96 96 0 0196 96z"
          opacity="0.2"
        ></path>
        <path d="M128 24a104 104 0 000 208c21.51 0 44.1-6.48 60.43-17.33a8 8 0 00-8.86-13.33C166 210.38 146.21 216 128 216a88 88 0 1188-88c0 26.45-10.88 32-20 32s-20-5.55-20-32V88a8 8 0 00-16 0v4.26a48 48 0 105.93 65.1c6 12 16.35 18.64 30.07 18.64 22.54 0 36-17.94 36-48A104.11 104.11 0 00128 24zm0 136a32 32 0 1132-32 32 32 0 01-32 32z"></path>
      </g>
    </svg>
  );
}

export default At;
